// 22.01.19 - The FormWrapper component implementation. This connects the data object with the Redux Form.
// The purpose of this component is twofold:
//    1. Check the URL subform params and display the right form based on it
//    2. Take care of initializing a new case or fetching a case that we haven't fetched yet
import { Redirect } from "react-router";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import { push } from "react-router-redux";
import {
  newCase,
  fetchCase,
  updateCase,
  saveCase,
  allowEditCase,
  caseLockUnlock,
  navigateHome,
} from "src/actions/detail";
import {
  initialize,
  // formValueSelector
} from "redux-form";
import {
  ICase,
  IUserDetail,
  IssueType,
  // isComplaint,
  Guid,
  UserRoles,
  // @ts-ignore
  CaseType,
  CASE_LOCK_UNLOCK,
  APP_NAME,
  AUTH_TOKEN,
  CaseFormType,
} from "src/constants/api";
import { IRootState } from "src/reducers";
import MainFormComponent from "./mainform";
import InventoryFormComponent from "./inventoryform";
import ShipmentFormComponent from "./shipmentform";
import ShipmentInventoryFormComponent from "./shipmentinventoryform";
import QMUFormComponent from "./qmuform";
import { withStyles, AppBar, Tabs, Tab, Typography } from "@material-ui/core";
import { generalStyles } from "src/styles/general";
// import { Loading } from "../common/loading_component";
import { Link } from "react-router-dom";
import FormToolbar from "./form_toolbar";
import {
  CustomCaseHeader,
  ToolbarWrapper,
  CustomCaseHeaderRoles,
} from "../../styles/general";
import { Loader } from "../common/loader.component";
import { Toaster } from "../common/toaster.component";
import {
  closeToaster,
  closeConfirmDialog,
  okConfirmDialog,
  openToaster,
} from "src/actions/common";
import ConfirmDialog from "../common/confirm-dialog.component";

import {
  checkFormValidation,
  checkValidationShipInv,
  checkMainFormValidation,
  checkQmuFormValidation,
  checkValidationInventory,
  // @ts-ignore
  HideForRoles,
  MAIN_FORM_REQUIRED,
} from "./form_utility";
import { getStringAfterSubstring, getStringBeforeSubstring } from "../../utils";
import AlertDialog from "../common/alert-dialog";
import ActionLogComponent from "./actionLog";
import { FORM_ERROR_MESSAGE } from "src/constants/data.js";
import MainFormIncidentReportComponent from "../detail/mainform-incident-report";
import ReduxFormConnectedMainFormWhNonconformityComponent from "./mainform-wh-nonconformity";

// @ts-ignore
interface IFormWrapperProps {
  // Whether this is a new case
  isNewCase: boolean;
  // Whether we're initializing a new case
  newCaseInitializing: boolean;
  // Whether this case is currently being saved
  isSaving: boolean;
  // The current user
  currentUser?: IUserDetail;
  // The selected case, if we had it in state already
  selectedCase?: ICase;
  // Otherwise we have the ID of the case that we need to fetch
  selectedCaseId?: string;
  // subform to render
  subform: string;
  // Tabs
  formTabs: Array<[string, ITab]>;
  // Actions
  newCase: any;
  initialize: typeof initialize;
  fetchCase: typeof fetchCase;
  saveCase: typeof saveCase;
  updateCase: typeof updateCase;
  isLoaderVisible: boolean;
  closeToaster: typeof closeToaster;
  toasterMessage: string;
  isToasterVisible: boolean;
  isSuccessMessage: boolean;
  caseData: ICase;
  currentRoleId: number;
  mainForm: any;
  allowEditCase: typeof allowEditCase;
  allowEdit: boolean;
  caseLockUnlock: typeof caseLockUnlock;
  navigateHome: typeof navigateHome;
  confirmDialog: any;
  closeConfirmDialog: typeof closeConfirmDialog;
  okConfirmDialog: typeof okConfirmDialog;
  isLockForEdit: any;
  currentUsername: string;
  isCurrentUserSO: boolean;
  isCurrentUserST: boolean;
  isCheckOutByDiffUser: boolean;
  openToaster: typeof openToaster;
}

export interface IFormWrapperParams {
  id: string;
  subform: string;
}

// The props the formwrapper has is a combination of the props we get from the Route
// and the props we get from mapDispatchToProps and mapStateToProps
// type FormWrapperProps = IFormWrapperProps &
//   RouteComponentProps<IFormWrapperParams> &
//   WithStyles<typeof generalStyles>;

interface ITab {
  title: string;
  component: any;
  predicate?: (state: IRootState) => boolean;
}

class FormWrapperImpl extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      tab: 0,
      isFixed: false,
      uniqueId: "",
      tabValue: "",
      alertDialog: {
        title: "",
        open: false,
        content: "",
      },
      showLoader: true,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }
  public render() {
    const {
      closeToaster,
      toasterMessage,
      isToasterVisible,
      isSuccessMessage,
      // caseData,
      // isNewCase,
      navigateHome,
      confirmDialog,
      closeConfirmDialog,
      // newCaseInitializing,
      // isSaving,
    } = this.props;
    const { alertDialog, showLoader } = this.state;
    // let showLoading = false;
    // if ((!caseData && !isNewCase) || newCaseInitializing || isSaving) {
    //   //  return <Loading />;
    //   showLoading = true;
    // } else {
    //   //  return this.renderContent();
    //   showLoading = false;
    // }

    return (
      <div>
        <Loader visible={showLoader} />
        <Toaster
          message={toasterMessage}
          open={isToasterVisible}
          close={closeToaster}
          success={isSuccessMessage}
        />
        <AlertDialog
          title={alertDialog.title}
          open={alertDialog.open}
          content={alertDialog.content}
          close={this.closeAlertDialog}
          ok={navigateHome}
        />
        <ConfirmDialog
          open={confirmDialog.open}
          close={closeConfirmDialog}
          title={confirmDialog.title}
          content={confirmDialog.content}
          ok={this.clickOkConfirmDialog}
        />
        {this.renderContent()}
      </div>
    );
  }

  public renderContent() {
    // const selectedCase: any = this.props.selectedCase;
    const {
      caseData,
      isNewCase,
      mainForm,
      currentRoleId,
      currentUser,
      isCurrentUserSO,
      isCurrentUserST,
    } = this.props;
    const { tabValue } = this.state;

    // @ts-ignore
    const formValues = mainForm.mainForm ? mainForm.mainForm.values : null;
    const forQmu = isNewCase && currentRoleId === UserRoles.QMU ? false : true;

    const isIncident = this.props.location.pathname.includes("incident-mainform");
    const isWhNonconformity = this.props.location.pathname.includes("wh-nonconformity-mainform");
    const showShipmentTab = formValues && formValues.issueType === IssueType.Shipment && !(
      currentUser &&
      currentUser.roleId === UserRoles.UNICEF &&
      tabValue === "incident-mainform"
    );
    const showInventoryTab = formValues
      && formValues.issueType === IssueType.Inventory
      && !(currentUser && currentUser.roleId === UserRoles.UNICEF && tabValue === "incident-mainform");
    const showShipmentInventoryTab = formValues
      && ![UserRoles.UNICEF, UserRoles.Solution_Owner, UserRoles.Solution_Team,].includes(currentRoleId)
      && forQmu
      && (isWhNonconformity
        ? (formValues.caseType === CaseType.Claim || formValues.caseType === CaseType.ComplaintClaim)
        : (formValues.issueType === IssueType.Shipment || formValues.issueType === IssueType.Inventory));
    const showComplaintSolutionsTab = formValues
      && currentRoleId !== UserRoles.UNICEF
      && (isWhNonconformity
        ? (formValues.caseType === CaseType.Complaint || formValues.caseType === CaseType.ComplaintClaim)
        : true);
    const showActionLogsTab = !isNewCase;

    return (
      <React.Fragment>
        <div style={{ position: "relative" }}>
          <ToolbarWrapper fixed={this.state.isFixed}>
            {this.renderToolbar()}
            {!isNewCase && caseData ? (
              currentRoleId === UserRoles.Partner ||
                currentRoleId === UserRoles.UNICEF ||
                currentRoleId === UserRoles.FMC ? (
                <CustomCaseHeaderRoles fixed={this.state.isFixed}>
                  {caseData.caseNo}
                </CustomCaseHeaderRoles>
              ) : (
                <CustomCaseHeader fixed={this.state.isFixed}>
                  {caseData.caseNo}
                </CustomCaseHeader>
              )
            ) : null}
          </ToolbarWrapper>

          <div
            style={{
              marginBottom: "10px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Typography variant="subtitle2" gutterBottom>
              {this.props.location.pathname.includes("incident-mainform") ? (
                <span style={{ marginLeft: "15px" }}>
                  Contact{" "}
                  <a href="mailto:cargoalert@unicef.org">
                    cargoalert@unicef.org
                  </a>{" "}
                  for incident reports support.
                </span>
              ) : (
                <>
                  <span>
                    Contact{" "}
                    <a href="mailto:sd.complaints@unicef.org">
                      sd.complaints@unicef.org
                    </a>{" "}
                    for complaints support.
                  </span>
                  <span style={{ marginLeft: "15px" }}>
                    Contact{" "}
                    <a href="mailto:sd.insurance@unicef.org">
                      sd.insurance@unicef.org
                    </a>{" "}
                    for claims support.
                  </span>
                </>
              )}
            </Typography>
          </div>

          <AppBar style={{ zIndex: 0 }} position="relative">
            <Tabs value={tabValue} onChange={this.handleChangeTab}>
              {isIncident
                ? <Tab label="Incident Main form" value="incident-mainform" />
                : isWhNonconformity
                  ? <Tab label="Warehouse Nonconformity" value="wh-nonconformity-mainform" />
                  : <Tab label="Main form" value="mainform" />
              }
              {showShipmentTab && <Tab label="Shipment" value="shipment" />}
              {showInventoryTab && <Tab label="Inventory" value="inventory" />}
              {showShipmentInventoryTab && <Tab label="Shipment / Inventory" value="shipmentinventory" />}
              {showComplaintSolutionsTab &&
                (isWhNonconformity?<Tab label="Solutions" value="qmu" />:
                  <Tab label="Complaint Solutions" value="qmu" />
                )
              }
              {showActionLogsTab && <Tab label="Action Logs" value="actionLog" style={{ marginLeft: "auto" }} />}
            </Tabs>
          </AppBar>

          {tabValue === "mainform" && (
            // @ts-ignore
            <MainFormComponent
              onSubmit={this.handleMainFormSubmit}
              // @ts-ignore
              routeParams={this.props.match}
              uniqueId={this.state.uniqueId}
              currentRoleId={this.props.currentRoleId}
              isNewCase={isNewCase}
            />
          )}

          {tabValue === "incident-mainform" && (
            // @ts-ignore
            <MainFormIncidentReportComponent
              onSubmit={this.handleMainFormSubmit}
              // @ts-ignore
              routeParams={this.props.match}
              uniqueId={this.state.uniqueId}
              currentRoleId={this.props.currentRoleId}
              isNewCase={isNewCase}
            />
          )}

          {tabValue === "wh-nonconformity-mainform" && (
            // @ts-ignore
            <ReduxFormConnectedMainFormWhNonconformityComponent
              onSubmit={this.handleMainFormSubmit}
              // @ts-ignore
              routeParams={this.props.match}
              uniqueId={this.state.uniqueId}
              currentRoleId={this.props.currentRoleId}
              isNewCase={isNewCase}
            />
          )}

          {tabValue === "shipment" && (
            <ShipmentFormComponent
              onSubmit={this.handleMainFormSubmit}
              routeParams={this.props.match}
              uniqueId={this.state.uniqueId}
              currentRoleId={this.props.currentRoleId}
              isNewCase={isNewCase}
            />
          )}
          {tabValue === "inventory" && (
            <InventoryFormComponent
              onSubmit={this.handleMainFormSubmit}
              routeParams={this.props.match}
              uniqueId={this.state.uniqueId}
              currentRoleId={this.props.currentRoleId}
              isNewCase={isNewCase}
            />
          )}
          {tabValue === "shipmentinventory" && (
            // @ts-ignore
            <ShipmentInventoryFormComponent
              onSubmit={this.handleMainFormSubmit}
              routeParams={this.props.match}
              uniqueId={this.state.uniqueId}
              currentRoleId={this.props.currentRoleId}
              isNewCase={isNewCase}
            />
          )}
          {tabValue === "qmu" && (
            // @ts-ignore
            <QMUFormComponent
              onSubmit={this.handleMainFormSubmit}
              routeParams={this.props.match}
              uniqueId={this.state.uniqueId}
              currentRoleId={this.props.currentRoleId}
              currentUser={currentUser}
              isNewCase={isNewCase}
              isCurrentUserSO={isCurrentUserSO}
              isCurrentUserST={isCurrentUserST}
            />
          )}
          {tabValue === "actionLog" && (
            <ActionLogComponent
              onSubmit={this.handleMainFormSubmit}
              routeParams={this.props.match}
            />
          )}
        </div>
      </React.Fragment>
    );
  }

  private clickOkConfirmDialog = () => {
    const { okConfirmDialog } = this.props;
    okConfirmDialog();
  };

  private handleChangeTab = (event: any, value: any) => {
    this.setState({ tabValue: value });
  };

  private closeAlertDialog = () => {
    this.setState({
      alertDialog: {
        open: false,
        title: "",
        content: "",
      },
    });
  };

  public renderTab = (key: any, tab: any) => (
    <Tab
      component={Link}
      key={key}
      value={key}
      label={tab.title}
      {...{ to: "./" + key }}
    />
  );

  public renderToolbar() {
    const {
      isNewCase,
      caseData,
      currentRoleId,
      allowEdit,
      currentUser,
      isLockForEdit,
      currentUsername,
      isCurrentUserSO,
      isCurrentUserST,
      isCheckOutByDiffUser,
    } = this.props;
    return (
      <FormToolbar
        isNewCase={isNewCase}
        caseData={caseData}
        roleId={currentRoleId}
        allowEdit={allowEdit}
        caseLockUnlock={this.props.caseLockUnlock}
        currentUser={currentUser}
        isLockForEdit={isLockForEdit}
        currentUsername={currentUsername}
        isCurrentUserSO={isCurrentUserSO}
        isCurrentUserST={isCurrentUserST}
        isCheckOutByDiffUser={isCheckOutByDiffUser}
      />
    );
  }

  public renderSubcomponent() {
    const { match, formTabs, subform } = this.props;
    const { uniqueId } = this.state;
    const res = formTabs.find((key: any) => key === subform);
    const Comp = res && res[1].component;
    return (
      (Comp && (
        <Comp
          onSubmit={this.handleMainFormSubmit}
          routeParams={match}
          uniqueId={uniqueId}
        />
      )) || <Redirect to="mainform" />
    );
  }

  // Lifecycle function.
  public componentDidMount() {
    if (this.props.isNewCase) {
      // If this is a new case, make sure we initialize the form with new values
      this.fnNewCase();
      // } else if (this.props.selectedCase) {
      //   // If we have the case data already, initialize the form with that data
      //   this.props.initialize("mainForm", this.props.selectedCase); // The Redux form action initialize sets the data to the Redux Form.

      this.setState({
        showLoader: false,
      });
    } else if (this.props.selectedCaseId) {
      // otherwise fetch the case as long as we have the ID. Calls Saga/effects and get the case from the DB.
      this.props.allowEditCase(false);
      this.props.fetchCase(this.props.selectedCaseId);
      this.setState({
        uniqueId: this.props.selectedCaseId,
        showLoader: true,
      });
    }

    this.props.location.pathname.includes("incident-mainform")
      ? this.setState({ tabValue: "incident-mainform" })
      : this.props.location.pathname.includes("wh-nonconformity-mainform")
        ? this.setState({ tabValue: "wh-nonconformity-mainform" })
        : this.setState({ tabValue: "mainform" });

    // scroll event added for making the header(toolbar options and Case no) fixed at top when scrolled
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("unload", this.handleWindowCloseUnload);
    window.addEventListener("beforeunload", this.handleWindowClose);
  }

  // Lifecycle function.
  public componentDidUpdate(prevProps: any) {
    if (prevProps.selectedCaseId !== this.props.selectedCaseId) {
      if (this.props.isNewCase) {
        this.fnNewCase();
        this.setState({
          showLoader: false,
        });
      } else {
        this.props.allowEditCase(false);
        this.props.fetchCase(this.props.selectedCaseId!);
        this.setState({
          uniqueId: this.props.selectedCaseId,
          showLoader: true,
        });
      }
    }

    if (prevProps.caseData !== this.props.caseData) {
      if (!this.props.isNewCase) {
        const { caseData, currentUser, currentRoleId } = this.props;
        const { submittingTeam } = caseData;
        let createdBy = caseData.createdBy;
        createdBy = getStringAfterSubstring(createdBy, "(");
        createdBy = getStringBeforeSubstring(createdBy, ")");
        createdBy = createdBy.trim();
        let username: any = currentUser ? currentUser.userName.trim() : "";

        if (username && username.includes(":")) {
          username = getStringAfterSubstring(username, ":").trim();
        }
        if (
          currentRoleId === UserRoles.UNICEF &&
          !(
            createdBy == username ||
            (submittingTeam &&
              submittingTeam.toLowerCase().includes(username.toLowerCase()))
          )
        ) {
          this.setState({
            alertDialog: {
              title: "Unauthorized Access",
              content: "You are not authorize to view this case",
              open: true,
            },
          });
        } else {
          this.props.allowEditCase(false);

          let caseData = this.props.caseData;
          if (caseData && caseData.supplyInfo && caseData.supplyInfo.length) {
            let supplyInfo = caseData.supplyInfo;
            supplyInfo.map((item: any, index: any) => {
              item.isTempExcusrsion =
                item.isTempExcusrsion === null ||
                  item.isTempExcusrsion === undefined
                  ? item.isTempExcusrsion
                  : item.isTempExcusrsion.toString();

              item.isDataMonitoringDeviceInstalled =
                item.isDataMonitoringDeviceInstalled === null ||
                  item.isDataMonitoringDeviceInstalled === undefined
                  ? item.isDataMonitoringDeviceInstalled
                  : item.isDataMonitoringDeviceInstalled.toString();
            });
            caseData.supplyInfos = supplyInfo;
          }

          if (caseData.unicefOrders) {
            caseData.unicefOrderNos = JSON.parse(caseData.unicefOrders);
          }
          this.props.initialize("mainForm", caseData);
        }
      }
    }

    if (prevProps.currentUser !== this.props.currentUser) {
      if (this.props.isNewCase) {
        this.fnNewCase();
      }
    }

    if (
      prevProps.location.pathname !== this.props.location.pathname &&
      this.props.location.pathname === "/detail/new/mainform"
    ) {
      this.setState({
        tabValue: "mainform",
      });
    } else if (
      prevProps.location.pathname !== this.props.location.pathname &&
      this.props.location.pathname.includes("incident-mainform")
    ) {
      this.setState({
        tabValue: "incident-mainform",
      });
    } else if (
      prevProps.location.pathname !== this.props.location.pathname &&
      this.props.location.pathname.includes("wh-nonconformity-mainform")
    ) {
      this.setState({
        tabValue: "wh-nonconformity-mainform",
      });
    }

    if (prevProps.isLoaderVisible !== this.props.isLoaderVisible) {
      this.setState({
        showLoader: this.props.isLoaderVisible,
      });
    }
  }

  public componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("beforeunload", this.handleWindowClose);
    window.removeEventListener("unload", this.handleWindowCloseUnload);
    const { isNewCase, caseData, allowEdit } = this.props;
    if (!isNewCase && allowEdit) {
      // @ts-ignore
      this.props.caseLockUnlock(caseData.uniqueId, -1);
    }
  }

  private fnNewCase = () => {
    this.props.newCase();
    this.props.allowEditCase(true);
    this.setState({
      uniqueId: Guid.newGuid(),
    });
  };

  // this function does not get called every time the submit button is pressed
  // it is called by redux form when after the form data has been validated
  private handleMainFormSubmit = (values: any, action: any, props: any) => {
    const { openToaster, currentUser } = this.props;
    const { tabValue } = this.state;
    if (values.unicefOrderNos && values.unicefOrderNos.length > 0) {
      values.UnicefOrders = JSON.stringify(values.unicefOrderNos);
    }
    const isMainFormValidated: any = this.validateMainForm(values, props);

    if (isMainFormValidated) {
      if (
        !(
          currentUser.roleId === UserRoles.UNICEF &&
          tabValue === "incident-mainform"
        )
      ) {
        // Validate QMU form
        const isQmuFormValidated: any = this.validateQmuForm(values, props);
        if (isQmuFormValidated && values.caseFormType !== CaseFormType.Incident) {
          if (isQmuFormValidated) {
            if (values.issueType === 1) {
              if ([1, 2, 3, 4].indexOf(values.inCaseOfShipment) >= 0) {
                if (!values.shipments || values.shipments.length === 0) {
                  this.setState(
                    {
                      tabValue: "shipment",
                    },
                    () => {
                      openToaster(FORM_ERROR_MESSAGE, false);
                    }
                  );

                  this.showShipmentInitialError(props);
                } else {
                  checkFormValidation(
                    values,
                    (success: any) => {
                      this.checkShipmentInvValidation(values, props);
                    },
                    (error: any) => {
                      if (error.length) {
                        this.setState(
                          {
                            tabValue: "shipment",
                          },
                          () => {
                            openToaster(FORM_ERROR_MESSAGE, false);
                          }
                        );
                      } else {
                        this.checkShipmentInvValidation(values, props);
                      }
                    }
                  );
                }
              } else {
                checkFormValidation(
                  values,
                  (success: any) => {
                    this.checkShipmentInvValidation(values, props);
                  },
                  (error: any) => {
                    if (error.length) {
                      this.setState(
                        {
                          tabValue: "shipment",
                        },
                        () => {
                          openToaster(FORM_ERROR_MESSAGE, false);
                        }
                      );
                    } else {
                      this.checkShipmentInvValidation(values, props);
                    }
                  }
                );
              }
            } else if (values.issueType === 6) {
              this.checkInventoryValidation(values, props);
            } else {
              this.proceedToSave(values);
            }
          } else {
            this.setState(
              {
                tabValue: "qmu",
              },
              () => {
                openToaster(FORM_ERROR_MESSAGE, false);
              }
            );
          }
        } else {
          this.proceedToSave(values);
        }
      } else {
        this.proceedToSave(values);
      }
    } else {
      const { tabValue } = this.state;
      // If there are errors in the mainform tab and the user is on some other tab, take the user to the mainform tab.
      if (tabValue !== "mainform") {
        this.setState(
          {
            tabValue: this.props.location.pathname.includes("incident-mainform")
              ? "incident-mainform"
              : this.props.location.pathname.includes("wh-nonconformity-mainform")
                ? "wh-nonconformity-mainform"
                : "mainform"
          },
          () => {
            openToaster(FORM_ERROR_MESSAGE, false);
          }
        );
      }
    }
  };

  private validateMainForm = (values: any, props: any) => {
    const { openToaster } = this.props;
    let isValidated: any;
    let requiredFields = MAIN_FORM_REQUIRED;
    if (this.props.location.pathname.includes("wh-nonconformity-mainform")) {
      requiredFields = requiredFields.filter((field: any) => !["phone", "complainant", "expectedLossValue"].includes(field));
    }
    checkMainFormValidation(
      values,
      requiredFields,
      (success: any) => {
        isValidated = true;
        closeToaster();
      },
      (error: any) => {
        if (error.length) {
          this.setState(
            {
              tabValue: this.props.location.pathname.includes("incident-mainform")
                ? "incident-mainform"
                : this.props.location.pathname.includes("wh-nonconformity-mainform")
                  ? "wh-nonconformity-mainform"
                  : "mainform"
            },
            () => {
              openToaster(FORM_ERROR_MESSAGE, false);
            }
          );
        }
        isValidated = false;
      }
    );
    return isValidated;
  };

  private validateQmuForm = (values: any, props: any) => {
    const { openToaster } = this.props;
    let isValidated: any;
    const qmusValues = values.qmus ? values.qmus[0] : null;
    checkQmuFormValidation(
      qmusValues,
      (success: any) => {
        isValidated = true;
      },
      (error: any) => {
        if (error.length) {
          this.setState(
            {
              tabValue: "qmu",
            },
            () => {
              openToaster(FORM_ERROR_MESSAGE, false);
            }
          );
        }
        isValidated = false;
      }
    );
    return isValidated;
  };

  private checkInventoryValidation = (values: any, props: any) => {
    const { openToaster } = this.props;
    checkValidationInventory(
      values.shipments[0],
      (success: any) => {
        this.checkShipmentInvValidation(values, props);
      },
      (error: any) => {
        if (error.length) {
          this.setState(
            {
              tabValue: "inventory",
            },
            () => {
              openToaster(FORM_ERROR_MESSAGE, false);
            }
          );
        } else {
          this.checkShipmentInvValidation(values, props);
        }
      }
    );
  };

  private checkShipmentInvValidation = (values: any, props: any) => {
    const { openToaster } = this.props;
    checkValidationShipInv(
      values.shipments[0],
      (success: any) => {
        this.proceedToSave(values);
      },
      (error: any) => {
        if (error.length) {
          this.setState(
            {
              tabValue: "shipmentinventory",
            },
            () => {
              openToaster(FORM_ERROR_MESSAGE, false);
            }
          );
        } else {
          this.proceedToSave(values);
        }
      }
    );
  };

  private proceedToSave(values: any) {
    const { uniqueId } = this.state;
    const { selectedCaseId, saveCase, updateCase } = this.props;
    if (!selectedCaseId) {
      saveCase(values, uniqueId);
    } else {
      updateCase(values);
    }
  }

  // @ts-ignore
  private errorHandler(props, error, route, model) {
    // props.dispatch(push(route));
    this.setState({
      tabValue: route,
    });
    setTimeout(() => {
      for (let i = 0; i < error.length; i++) {
        props.touch(`${model}[0].${error[i]}`);
      }
    }, 100);
  }

  private showShipmentInitialError = (props: any) => {
    setTimeout(() => {
      props.touch("shipments[0].description");
      props.touch("shipments[0].tampering");
      props.touch("shipments[0].sealIntact");
      props.touch("shipments[0].packingIntact");
      props.touch("shipments[0].containerNo");
      // props.touch("shipments[0].dateReceivedInCountry");
      props.touch("shipments[0].quantity");
      // props.touch("shipments[0].customsClearanceDate");
    }, 100);
  };

  // @ts-ignore
  private showShipmentInvInitialError = (props) => {
    setTimeout(() => {
      props.touch("shipments[0].nameOfThirdParty");
      props.touch("shipments[0].contactPerson");
      props.touch("shipments[0].sdaddress");
      props.touch("shipments[0].email");
      props.touch("shipments[0].telephone");
      props.touch("shipments[0].brokerReference");
      props.touch("shipments[0].claimDesignation");
    }, 100);
  };

  private handleScroll() {
    if (window.scrollY >= 50) {
      this.setState({ isFixed: true });
    } else {
      this.setState({ isFixed: false });
    }
  }

  private handleWindowCloseUnload = (event: any) => {
    event.preventDefault();
    const { caseData, isNewCase, allowEdit } = this.props;
    if (!isNewCase && allowEdit) {
      const data = {
        app_name: APP_NAME,
        auth_token: AUTH_TOKEN,
        checkoutData: {
          uniqueId: caseData.uniqueId,
          username: -1,
        },
        url: CASE_LOCK_UNLOCK,
      };

      // Code commented for future use through sendBeacon api
      // const headers = {
      //   "type": "application/x-www-form-urlencoded"

      // };
      // let blob = new Blob([JSON.stringify(data)], headers);
      // navigator.sendBeacon('url', blob);

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${data.url}/${data.checkoutData.uniqueId}/${data.checkoutData.username}`,
        false
      );
      // Send the proper header information along with the request
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.setRequestHeader("AuthenticationToken", data.auth_token);
      xhr.setRequestHeader("AppName", data.app_name);

      xhr.send();
    }
  };
  private handleWindowClose = (event: any) => {
    // event.preventDefault();
    // event.returnValue = "";
  };
}

// This maps the action creators we need in FormWrapper to our props. So we can access these actions.
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      saveCase,
      updateCase,
      newCase,
      fetchCase,
      initialize,
      closeToaster,
      allowEditCase,
      caseLockUnlock,
      navigateHome,
      closeConfirmDialog,
      okConfirmDialog,
      openToaster,
    },
    dispatch
  );

// When connecting the FormWrapper to the state store, we try to get the case with the
// correct ID from the state, if we have it. Otherwise, we set the props such that it will
// be fetched by the FormWrapper
function mapStateToProps(state: IRootState, ownProps: any) {
  // ownProps.match are given to us by react-router because this component is
  // wrapped in a Route
  const caseId = ownProps.match.params.id; // Comes as parameter from route URL.
  const isNewCase = caseId === "new"; // Comes as parameter from the New Case route URL.

  // The code below was used to check if the form had been initialized, and to display the loading
  // screen if it was not. This solution doesn't work, however.
  // For now, `newCaseInitializing` is just always set to false below
  // A possible alternative solutin is to look into whether redux-form doesn't have something in its
  // state that lets us determine whether the form has been initialized
  // const email: string | undefined = formValueSelector("mainForm")(
  //   state,
  //   "createdBy",
  // );
  const props = isNewCase
    ? {
      isSaving: state.detail.caseSaveInProgress,
      currentUser: state.home.currentUser,
      isNewCase: true,
      newCaseInitializing: false,
      selectedCase: undefined,
      selectedCaseId: undefined,
      subform: ownProps.match.params.subform, // Comes as parameter from route URL
      // formTabs: tabs.filter(([key, tab]) =>
      //   tab.predicate ? tab.predicate(state) : true
      // ),
      isLoaderVisible: state.common.isLoaderVisible,
      toasterMessage: state.common.toasterMessage,
      isToasterVisible: state.common.isToasterVisible,
      isSuccessMessage: state.common.isSuccess,
      caseData: state.detail.caseData,
      currentRoleId: state.home.currentUser && state.home.currentUser.roleId,
      mainForm: state.form,
      allowEdit: state.detail.allowEdit,
      confirmDialog: state.common.confirmDialog,
      isLockForEdit: state.detail.isLockForEdit,
      currentUsername: state.detail.currentUsername,
      isCurrentUserSO: state.detail.isCurrentUserSO,
      isCurrentUserST: state.detail.isCurrentUserST,
      isCheckOutByDiffUser: state.detail.isCheckOutByDiffUser,
    }
    : {
      isSaving: state.detail.caseSaveInProgress,
      currentUser: state.home.currentUser,
      newCaseInitializing: false,
      isNewCase: false,
      selectedCase: state.home.caseData && state.home.caseData.get(caseId),
      selectedCaseId: caseId,
      subform: ownProps.match.params.subform, // Comes as parameter from route URL
      // formTabs: tabs.filter(([key, tab]) =>
      //   tab.predicate ? tab.predicate(state) : true
      // ),
      isLoaderVisible: state.common.isLoaderVisible,
      toasterMessage: state.common.toasterMessage,
      isToasterVisible: state.common.isToasterVisible,
      isSuccessMessage: state.common.isSuccess,
      caseData: state.detail.caseData,
      currentRoleId: state.home.currentUser && state.home.currentUser.roleId,
      mainForm: state.form,
      allowEdit: state.detail.allowEdit,
      confirmDialog: state.common.confirmDialog,
      isLockForEdit: state.detail.isLockForEdit,
      currentUsername: state.detail.currentUsername,
      isCurrentUserSO: state.detail.isCurrentUserSO,
      isCurrentUserST: state.detail.isCurrentUserST,
      isCheckOutByDiffUser: state.detail.isCheckOutByDiffUser,
    };

  return props;
}

// connect the form wrapper to the state store
export const FormWrapper = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(generalStyles)(FormWrapperImpl));
